"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryIndexItemAbstract = exports.CategoryItemType = void 0;
const base_1 = require("../base");
var CategoryItemType;
(function (CategoryItemType) {
    CategoryItemType["Category"] = "categorypage";
})(CategoryItemType || (exports.CategoryItemType = CategoryItemType = {}));
class CategoryIndexItemAbstract extends base_1.BaseIndexItemAbstract {
    constructor() {
        super(...arguments);
        this.type = CategoryItemType.Category;
    }
}
exports.CategoryIndexItemAbstract = CategoryIndexItemAbstract;
